import { unstable_batchedUpdates } from 'react-dom'

let queue: (() => void)[] = []

function batchedUpdates(cb: () => void) {
  if (!queue.length) {
    setTimeout(() => {
      unstable_batchedUpdates(() => {
        queue.forEach((cb) => {
          cb()
        })
      })
      queue = []
    })
  }
  queue.push(cb)
}

export default batchedUpdates
